import { Image, Video } from '@prisma/client';

export function getFileUrl(media: Video | Image) {
  return media.s3Key ? encodeURI(`/api/s3?key=${media.s3Key}`) : media.url;
}

/**
 * Appends a query parameter to the given URL to automatically open the Protege AI addon.
 *
 * @param link - The original URL to which the query parameter will be added.
 * @returns The modified URL with the 'auto_open_protege_ai' query parameter set to 'true'.
 */

export const getAutoOpenAddonUrl = (link: string) => {
  if (!link) return link;
  const url = new URL(link);
  url.searchParams.set('auto_open_protege_ai', 'true');
  return url.toString();
};

// https, http
export const removeProtocolOnUrl = (link: string) => link.replace(/^https?:\/\//, '');
